// extracted by mini-css-extract-plugin
module.exports = {"wrapperLogo":"Logo__wrapperLogo_1jWzG","link":"Logo__link_25FmS"};